import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { ClosePopup } from '../assets/images';
import WebChatLogout from '../Components/WebChat/Authentication/WebChatLogout';
import WebChatPopup from '../Components/WebChat/Authentication/WebChatPopup';
import ActionPopUp from '../Components/WebChat/Common/ActionPopUp';
import ParticipantPopUp from '../Components/WebChat/Common/ParticipantsPopUp';
import CreateNewGroup from '../Components/WebChat/NewGroup';
import RecentChatSection from '../features/recentChat';
import ChatListHeader from '../features/recentChat/ChatListHeader';
import InviteDialog from '../features/recentChat/InviteDialog';
import CreateChatHost from '../features/createChat/CreateChatHost';
import { CREATE_CHAT_FLOW, CREATE_CHAT_PERMISSION_DENIED } from '../features/createChat/constants';
import StarredMessages from '../Components/WebChat/Starred/StarredMessages';
import { i18n } from '../localization/i18n';
import { STATIC_HOME_BADGE, STATIC_SERVICES_BADGE } from '../features/recentChat/fr59PendingBackend';
import CallParticipantsPopup from '../Components/WebCall/ParticipantsPopUp';
import CallLogsLeftPanel from '../features/callLogs/CallLogsLeftPanel';
import Setting from '../Components/WebChat/Setting';
import WebChatRoster from '../Components/WebChat/WebChatRoster';
import WebChatVCard from '../Components/WebChat/WebChatVCard/WebChatVCard';
import MediaErrorPopup from '../Components/WebCall/MediaErrorPopup';
import CallConversionPopup from '../Components/WebCall/CallConversionPopup';
import callLogsObj from '../Components/WebCall/CallLogs/callLog';
import { fetchingCallLog } from '../Actions/CallLogAction';
import { Store } from '../store';
import {
    CALL_CONVERSION_STATUS_ACCEPT,
    CALL_CONVERSION_STATUS_CANCEL,
    CALL_CONVERSION_STATUS_DECLINE,
    CALL_CONVERSION_STATUS_REQUEST,
    CALL_CONVERSION_STATUS_REQ_WAITING,
} from '../Helpers/Call/Constant';
import { UpdateArchiveChatDataAction } from '../Actions/Common';
import Modal from '../Components/WebChat/Common/Modal';
import ActionPopup from '../Components/ActionPopup/index';
import { showModal } from '../Actions/PopUp';
import { disconnectCallConnection } from '../Helpers/Call/Call';
import { callIntermediateScreen, resetConferencePopup } from '../Actions/CallAction';
import { CHAT_COUNT_DISPLAY_MAX, CHAT_FILTER, NEW_CHAT_CONTACT_PERMISSION_DENIED } from '../Helpers/Chat/Constant';
import { SIDEBAR_MENU_INDEX } from '../Helpers/Constants';
import { countByChatFilter } from '../Helpers/Chat/ChatFilter';
import { encryptAndStoreInLocalStorage } from '../Components/WebChat/WebChatEncryptDecrypt';
import userList from '../Components/WebChat/Common/userList';
import { REACT_APP_CONTACT_SYNC } from '../Components/processENV';
import Channels from '../channels';
import Invitiations from '../channels/Invitiations';
import { setTabActiveStatus } from '../channels/utils';
// icons

import { resetWallpaperColor, wallpaperPreviewSection } from '../Actions/WallpaperActions';
import { requestCall } from '../slice/commonSlice';
import { CALL_TYPE } from '../features/calls/constants';
import StoriesSection from '../Components/Stories/index';
import { RailCallsIcon, RailChatIcon, RailSettingsIcon } from '../Components/Common/Icons';
import RailPlaceholderIcon from '../Components/Layouts/RailPlaceholderIcon';
import DazwayRailLogo from '../Components/Layouts/DazwayRailLogo';
import RailThemeToggle from './RailThemeToggle';

export const navigateChannel = createRef(null);

/* Rail entries in display order: Home, Calls, Services, Chat, Settings.
 *
 * `index` is the argument handleMenuIconActiveStatus switches on, and it is also published
 * to Redux as activeMenuIndex, which Login.jsx and CallLogsLeftPanel read as "1 = Calls"
 * and ConversationSection as "3 = Stories". So the indices stay exactly as they were and
 * only the display order changes — reordering the numbers would reroute those screens.
 * Stories (3) and Profile (4) are left out of the rail; their branches remain reachable. */
const RAIL_ITEMS = [
    { key: 'home', type: 'placeholder', variant: 'home', labelKey: 'chat.rail.HOME' },
    { key: 'calls', type: 'nav', index: 1, labelKey: 'chat.rail.CALLS', Icon: RailCallsIcon },
    { key: 'services', type: 'placeholder', variant: 'services', labelKey: 'chat.rail.SERVICES' },
    { key: 'chat', type: 'nav', index: 0, labelKey: 'chat.rail.CHAT', Icon: RailChatIcon },
    { key: 'settings', type: 'nav', index: 2, labelKey: 'chat.rail.SETTINGS', Icon: RailSettingsIcon },
];

const RAIL_BADGE = {
    home: STATIC_HOME_BADGE,
    services: STATIC_SERVICES_BADGE,
};

/**
 * How many conversations carry unread messages, matching the Unread chip exactly.
 *
 * The chip counts conversations rather than messages, and leaves archived ones out. Both
 * rules come from countByChatFilter, which is reused here so the two numbers cannot drift
 * apart; the store keeps recent chats flat, so each one is wrapped the way the chat list
 * wraps them before it is handed over.
 *
 * @param state Redux state.
 * @returns Number of unread conversations.
 */
const countUnreadChats = state => {
    const chats = state?.recentChatData?.data || [];
    const unreadDataObj = state?.unreadCountData?.unreadDataObj || {};
    const scope = chats.filter(chat => chat?.archiveStatus !== 1).map(chat => ({ recent: chat }));

    return countByChatFilter(scope, unreadDataObj)[CHAT_FILTER.UNREAD];
};

class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.currentUserRequestingCallSwitch = false;
        this.remoteUserRequestingCallSwitch = false;
        this.menuRef = React.createRef();
        this.state = {
            menuDropDownStatus: false,
            popupStatus: false,
            newChatStatus: true,
            newChatStatusLevel: '',
            newGroupParticipants: false,
            archivedChatList: false,
            menuSetGroupImage: false,
            chatLogs: false,
            handleBackStatus: false,
            callLogs: false,
            settingStatus: false,
            archivedSetting: false,
            callLogCount: 1,
            channelsStatus: false,
            invitationsStatus: false,
            webChatRosterStatus: false,
            showProfilePageNew: false,
            setMenuActiveStatus: 0,
            // tempActiveIndex: null,
            selectedMenuName: 'Chats',
            storiesStatus: false,
            newCall: false,
            newCallType: '',
            inviteDialogOpen: false,
            starredOpen: false,
            createChatFlow: null,
        };
    }

    handleLogutStatus = status => {
        this.setState({ popupStatus: status, menuDropDownStatus: false });
    };

    handleMenuIconActiveStatus = index => {
        // this.setState({ setMenuActiveStatus: index, tempActiveIndex: null });
        //preview section close
        this.props.wallpaperPreviewSection(false);
        switch (index) {
            case SIDEBAR_MENU_INDEX.CHATS:
                this.setState({
                    selectedMenuName: 'Chats',
                    showProfilePageNew: false,
                    archivedChatList: false,
                    storiesStatus: false,
                });
                if (this.state.callLogs) {
                    this.handleBackFromCallLogs(true);
                } else if (this.state.settingStatus) {
                    this.handleBackFromSetting();
                } else if (this.state.channelsStatus) {
                    this.handleChannelsClick(false);
                } else if (!this.state.newChatStatus) {
                    this.setState({ newChatStatus: true });
                }
                break;
            // case 1:
            //   this.setState({ selectedMenuName: "Channels" });
            //   this.handleChannelsClick();
            //   if (this.state.callLogs) {
            //     this.handleChannelsClick(true);
            //   }
            //   else if (this.state.settingStatus) {
            //     this.handleBackFromSetting();
            //   }
            //   break;
            case SIDEBAR_MENU_INDEX.CALL_LOGS:
                this.setState({
                    selectedMenuName: 'Call Logs',
                    showProfilePageNew: false,
                    archivedChatList: false,
                    storiesStatus: false,
                });
                this.handleCallLogs();
                if (this.state.settingStatus) {
                    this.handleBackFromSetting();
                }
                break;
            case SIDEBAR_MENU_INDEX.SETTINGS:
                this.setState({
                    selectedMenuName: 'Settings',
                    showProfilePageNew: false,
                    archivedChatList: false,
                    storiesStatus: false,
                });
                this.handleSetting();
                if (this.state.callLogs) {
                    this.handleBackFromCallLogs(true);
                } else if (this.state.channelsStatus) {
                    this.handleBackFromCallLogs(true);
                }
                break;
            case SIDEBAR_MENU_INDEX.PROFILE:
                // Profile is an overlay, so the list underneath must be reset explicitly:
                // leaving Call Logs mounted would keep its scroll position behind the popup.
                this.setState({
                    showProfilePageNew: true,
                    selectedMenuName: 'Profile',
                    archivedChatList: false,
                    storiesStatus: false,
                    callLogs: false,
                    settingStatus: false,
                    channelsStatus: false,
                    newChatStatus: true,
                });
                break;
            default:
                break;
        }
        this.setState({ setMenuActiveStatus: index });
        Store.dispatch(setTabActiveStatus(index));
    };

    handleNewCallNavigation = type => {
        if (!REACT_APP_CONTACT_SYNC) {
            userList.getUsersListFromSDK(1);
        }
        this.setState({
            newGroupParticipants: true,
            newCall: true,
            newCallType: type,
            menuDropDownStatus: false,
            callLogs: false,
        });
    };

    handleBackFromNewCall = () => {
        this.setState({
            newGroupParticipants: false,
            newCall: false,
            newCallType: '',
            callLogs: true,
        });
    };

    handleMakeNewCall = (type, participants) => {
        if (!participants || participants.length === 0) return;

        const isVideoCall = type === 'video';
        const userIds = participants.map(p => p.userId);
        const maxUsers = parseInt(process.env.REACT_APP_MAX_USERS_CALL) || 4;

        if (userIds.length > maxUsers - 1) {
            toast.error(`Maximum ${maxUsers} members allowed in a call`);
            return;
        }

        if (userIds.length === 1) {
            this.props.requestCall({
                userId: userIds[0],
                callType: isVideoCall ? CALL_TYPE.VIDEO : CALL_TYPE.AUDIO,
            });
        } else {
            this.props.requestCall({
                userIds: userIds,
                groupId: null,
                callType: isVideoCall ? CALL_TYPE.VIDEO : CALL_TYPE.AUDIO,
                isGroup: true,
            });
        }

        this.handleBackFromNewCall();
    };

    // handleSidebarUlMouseEnter = () => {
    //   this.setState({ tempActiveIndex: this.state.setMenuActiveStatus, setMenuActiveStatus: null });
    // };

    // handleSidebarUlMouseLeave = () => {
    //   if (this.state.tempActiveIndex !== null) {
    //     this.setState({ setMenuActiveStatus: this.state.tempActiveIndex, tempActiveIndex: null });
    //   }
    // };

    handleOpenInvite = () => {
        this.setState({ inviteDialogOpen: true });
    };

    handleInviteOpenChange = open => {
        this.setState({ inviteDialogOpen: open });
    };

    // The archived list lives inside the recent-chat pane, so opening it is a matter of
    // telling that pane to switch, not of swapping the pane out here.
    handleOpenArchived = () => {
        Store.dispatch(UpdateArchiveChatDataAction({ isArchived: true }));
    };

    handleOpenStarred = () => {
        this.setState({ starredOpen: true });
    };

    handleBackFromStarred = () => {
        this.setState({ starredOpen: false });
    };

    outsidePopupClick = e => {
        const { popUpData: { modalProps: { open } = {} } = {} } = this.props;

        if (open) return;

        if (this.menuRef.current && !this.menuRef.current.contains(e.target)) {
            this.setState({ menuDropDownStatus: false, popupStatus: false });
        }
    };

    handleNewChat = () => {
        if (this.props.contactPermission === 0) {
            this.props.handleContactPermissionPopup(true, NEW_CHAT_CONTACT_PERMISSION_DENIED);
            return;
        }
        if (!REACT_APP_CONTACT_SYNC) {
            userList.getUsersListFromSDK(1);
        }
        this.setState({ newChatStatus: false, callLogs: false });
    };

    handleCallLogs = () => {
        this.setState({
            newChatStatus: false,
            callLogs: true,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            invitationsStatus: false,
            channelsStatus: false,
            webChatRosterStatus: false,
        });
        const { callLogData } = this.props;
        const hasCallLogs = Object.keys(callLogData.callLogs || {}).length > 0;
        if (!hasCallLogs && !callLogData.isFetchingCallLog) {
            Store.dispatch(fetchingCallLog(true));
            callLogsObj.getCallLogsFromServer(1);
        }
    };

    handleChatsClick = () => {
        this.props.handlePopupState(true);
        let statusView = 'block';
        this.props.handleConversationSectionDisplay(statusView);
        this.setState({
            newChatStatus: true,
            callLogs: false,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            invitationsStatus: false,
            channelsStatus: false,
            webChatRosterStatus: false,
        });
    };

    handleChannelsClick = (channelsStatus = true) => {
        this.setState({
            channelsStatus,
            invitationsStatus: false,
            newChatStatus: !channelsStatus,
            callLogs: false,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            webChatRosterStatus: false,
        });
    };
    handleInvitationsClick = () => {
        this.setState({
            invitationsStatus: true,
            channelsStatus: false,
            newChatStatus: false,
            callLogs: false,
            settingStatus: false,
            archivedChatList: false,
            newGroupParticipants: false,
            webChatRosterStatus: false,
        });
    };

    /**
     * handleBackStatus() manage view of recent chat or conversatipon page in responsive mode.
     * Also manage view of recent chat or roster.
     */
    handleBackStatus = status => {
        this.props.handlePopupState(status);
        let statusView = 'block';
        this.setState({ newChatStatus: status }, () => {
            this.props.handleConversationSectionDisplay(statusView);
        });
    };

    handleDropdownStatus = _status => {
        this.setState({ menuDropDownStatus: !this.state.menuDropDownStatus });
    };

    handleOpenCreateChat = flow => {
        if (this.props.contactPermission === 0) {
            this.props.handleContactPermissionPopup(true, CREATE_CHAT_PERMISSION_DENIED[flow]);
            return;
        }
        this.setState({ createChatFlow: flow });
    };

    handleBackToRecentChat = () => {
        this.setState(
            {
                newGroupParticipants: false,
                archivedChatList: false,
            },
            () => {
                Store.dispatch(UpdateArchiveChatDataAction({ isArchived: false }));
            },
        );
    };
    handleBackToRecentChatFromInvite = () => {
        this.setState(
            {
                newGroupParticipants: false,
                archivedChatList: false,
                invitationsStatus: false,
                channelsStatus: false,
                newChatStatus: true,
                menuDropDownStatus: false,
            },
            () => {
                Store.dispatch(UpdateArchiveChatDataAction({ isArchived: false }));
            },
        );
    };

    handleSetting = () => {
        this.setState({
            settingStatus: true,
        });
    };
    handleBackFromSetting = () => {
        this.setState({
            settingStatus: false,
        });
    };
    handleBackFromCallLogs = status => {
        this.setState({ newChatStatus: status });
        this.setState({ callLogs: false });
        this.setState({ channelsStatus: false });
        this.setState({ selectedMenuName: 'Chats' });
    };

    browserNotifyRedirect = prevProps => {
        // When click on missed call notification, need to redirect to calllog page
        // We check the browserNotify pageName is 'calllog', then swith the page to calllog
        const prevPropsBrowserNotifyData = prevProps.browserNotifyData;
        const browserNotifyData = this.props.browserNotifyData;
        if (
            browserNotifyData.pageName &&
            prevPropsBrowserNotifyData.pageName !== browserNotifyData.pageName &&
            browserNotifyData.pageName === 'calllog'
        ) {
            this.handleCallLogs();
        }
    };
    handleClickOutside = event => {
        if (
            this.menuRef.current &&
            !this.menuRef.current.contains(event.target) &&
            !event.target.closest('.menu-icon')
        ) {
            this.setState({ menuDropDownStatus: false });
        }
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate = prevProps => {
        this.browserNotifyRedirect(prevProps);
    };

    resetCallConversionRequestData = () => {
        this.currentUserRequestingCallSwitch = false;
        this.remoteUserRequestingCallSwitch = false;
    };

    renderRecentChat = pageType => {
        return (
            <RecentChatSection
                pageType={pageType}
                handleConversationSectionDisplay={this.props.handleConversationSectionDisplay}
                handleBackStatus={this.handleBackStatus}
                callUserJID={this.props.callUserJID}
                callStatus={this.props.callStatus}
                newChatStatus={this.state.newChatStatus}
                handleShowCallScreen={this.props.handleShowCallScreen}
                callType={this.props.callType}
                callMode={this.props.callMode}
                handlePopupState={this.props.handlePopupState}
            />
        );
    };

    closeModel = modelType => {
        Store.dispatch(
            showModal({
                open: false,
                modelType,
            }),
        );
    };

    handleJoinCallAction = () => {
        encryptAndStoreInLocalStorage('isNewCallExist', true);
        disconnectCallConnection();
        Store.dispatch(resetConferencePopup());
        this.closeModel('CallConfirm');
        const newLink = this.props.popUpData?.modalProps?.newCallLink;
        setTimeout(() => {
            Store.dispatch(callIntermediateScreen({ show: true, link: newLink }));
        }, 10);
    };

    handleCancel = () => {
        this.closeModel('CallConfirm');
    };

    render() {
        let {
            popupStatus,
            newChatStatus,
            newGroupParticipants,
            settingStatus,
            callLogs,
            archivedChatList,
            channelsStatus,
            invitationsStatus,
            setMenuActiveStatus,
            selectedMenuName,
            showProfilePageNew,
            storiesStatus,
            inviteDialogOpen,
            starredOpen,
            createChatFlow,
        } = this.state;

        const {
            vCardData,
            popUpData: {
                modalProps: { open, modelType },
            },
            callConversionData,
            featureStateData,
        } = this.props;
        navigateChannel.current = {
            toInvitations: this.handleInvitationsClick,
            toRecentChannels: this.handleChannelsClick,
            toChats: this.handleChatsClick,
            toCallLogs: this.handleCallLogs,
            toSettings: this.handleSetting,
        };
        const { isGroupChatEnabled = false } = featureStateData;
        if (callConversionData && callConversionData.status) {
            if (callConversionData.status === CALL_CONVERSION_STATUS_ACCEPT) {
                if (this.remoteUserRequestingCallSwitch === true && this.currentUserRequestingCallSwitch === true) {
                    this.currentUserRequestingCallSwitch = false;
                }
                this.remoteUserRequestingCallSwitch = false;
            } else if (callConversionData.status === CALL_CONVERSION_STATUS_REQ_WAITING) {
                this.currentUserRequestingCallSwitch = true;
            } else if (callConversionData.status === CALL_CONVERSION_STATUS_REQUEST) {
                this.remoteUserRequestingCallSwitch = true;
            } else if (callConversionData.status === CALL_CONVERSION_STATUS_CANCEL || CALL_CONVERSION_STATUS_DECLINE) {
                this.resetCallConversionRequestData();
            }
        }

        return (
            <>
                {/* <LeftMenuNavigation
                    state={this.state}
                    onCallsLogClick={this.handleCallLogs}
                    onClickChats={this.handleChatsClick}
                    onClickSettings={this.handleSetting}
                    onChannelsClick={this.handleChannelsClick}
                    onInvitationsClick={this.handleInvitationsClick}
                /> */}
                <nav className={`sidebar_menu ${showProfilePageNew ? 'showProfilePage' : ''}`}>
                    <div className="sidebar_logo">
                        <DazwayRailLogo />
                    </div>
                    <ul>
                        {RAIL_ITEMS.map(item => {
                            const label = i18n.t(item.labelKey);

                            if (item.type === 'placeholder') {
                                return (
                                    <li
                                        className="sidebar_placeholder"
                                        key={item.key}
                                        title={label}
                                        aria-disabled="true"
                                    >
                                        <RailPlaceholderIcon
                                            label={label}
                                            badge={RAIL_BADGE[item.variant]}
                                            variant={item.variant}
                                        />
                                    </li>
                                );
                            }

                            const { Icon } = item;
                            const isActive = item.index === setMenuActiveStatus;
                            // Only Chat carries a live count; the rest have nothing to report.
                            const badge = item.key === 'chat' ? this.props.unreadChatsCount : 0;

                            return (
                                <li
                                    style={{ cursor: 'pointer' }}
                                    key={item.key}
                                    title={label}
                                    onClick={() => this.handleMenuIconActiveStatus(item.index)}
                                    className={`sidebar_icon ${isActive ? 'active' : ''}`}
                                >
                                    {/* The badge overlaps the glyph, so it anchors to a box
                                     * that wraps the glyph rather than to the whole tile. */}
                                    <span className="sidebar_icon_glyph">
                                        <Icon />
                                        {badge > 0 && (
                                            <span className="sidebar_icon_badge">
                                                {badge > CHAT_COUNT_DISPLAY_MAX ? `${CHAT_COUNT_DISPLAY_MAX}+` : badge}
                                            </span>
                                        )}
                                    </span>
                                    <span className="sidebar_icon_label">{label}</span>
                                </li>
                            );
                        })}
                    </ul>
                    <div className="sidebar_foot">
                        <div className={`profile_img`}>
                            <WebChatVCard showProfilePageNew={showProfilePageNew} />
                        </div>
                        {/* Reuses the existing logout flow rather than reimplementing it. */}
                        <ul className="sidebar_foot_actions">
                            <WebChatLogout
                                history={this.props.history}
                                logoutStatus={this.handleLogutStatus}
                                handleDropdownStatus={this.handleDropdownStatus}
                            />
                        </ul>
                        <RailThemeToggle />
                    </div>
                </nav>
                <div className="recent-chatlist">
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        {/* handleSetting and friends only switch their own flag on, leaving
                            newChatStatus true, so the chat list would render underneath the
                            pane that replaced it. Starred is the exception: it keeps the list
                            header above it, so only the list itself gives way. */}
                        {newChatStatus &&
                            !settingStatus &&
                            !callLogs &&
                            !channelsStatus &&
                            !invitationsStatus &&
                            !storiesStatus && (
                                <>
                                    <ChatListHeader
                                        title={selectedMenuName}
                                        archivedCount={this.props.archivedChatsCount}
                                        starredCount={this.props.starredMessagesCount}
                                        isGroupChatEnabled={isGroupChatEnabled}
                                        onNewContact={() => this.handleOpenCreateChat(CREATE_CHAT_FLOW.CONTACT_LIST)}
                                        onNewGroup={() => this.handleOpenCreateChat(CREATE_CHAT_FLOW.NEW_GROUP)}
                                        onInvite={this.handleOpenInvite}
                                        onArchived={this.handleOpenArchived}
                                        onStarred={this.handleOpenStarred}
                                    />
                                    {/* Starred replaces the list, not the header above it. */}
                                    {starredOpen ? (
                                        <StarredMessages
                                            inline
                                            handleBackToSetting={this.handleBackFromStarred}
                                            featureStateData={this.props.featureStateData}
                                            handleShowCallScreen={this.props.handleShowCallScreen}
                                        />
                                    ) : (
                                        this.renderRecentChat('recent')
                                    )}
                                </>
                            )}

                        {callLogs && (
                            <CallLogsLeftPanel
                                handleShowCallScreen={this.props.handleShowCallScreen}
                                handleNewCallNavigation={this.handleNewCallNavigation}
                                handleNewChat={this.handleNewChat}
                            />
                        )}

                        {settingStatus && (
                            <Setting
                                handleBackFromSetting={this.handleBackFromSetting}
                                logoutStatus={this.handleLogutStatus}
                                featureStateData={featureStateData}
                                handleShowCallScreen={this.props.handleShowCallScreen}
                            />
                        )}

                        {channelsStatus && <Channels handleChannelsClick={this.handleChannelsClick} />}
                        {invitationsStatus && (
                            <>
                                <div className="recent-chatlist-header">
                                    <div className="profile-img-name">
                                        <i
                                            className="newchat-icon-channel"
                                            title="Back"
                                            onClick={this.handleBackToRecentChatFromInvite}
                                        >
                                            <ClosePopup style={{ fill: '#0158E6' }} />
                                        </i>
                                        <span>{'Channel requests'}</span>
                                    </div>
                                </div>
                                <Invitiations handleChannelsClick={this.handleChannelsClick} />
                            </>
                        )}
                        {storiesStatus && <StoriesSection />}

                        {!newChatStatus &&
                            !channelsStatus &&
                            !invitationsStatus &&
                            !callLogs &&
                            !archivedChatList &&
                            !settingStatus &&
                            !storiesStatus && (
                                <WebChatRoster newChatStatus={newChatStatus} handleBackStatus={this.handleBackStatus} />
                            )}
                        {popupStatus && (
                            <WebChatPopup history={this.props.history} logoutStatus={this.handleLogutStatus} />
                        )}
                    </div>
                    {/* </OutsideClickHandler> */}
                    {newGroupParticipants && (
                        <CreateNewGroup
                            vCardData={vCardData}
                            handleBackToRecentChat={this.handleBackToRecentChat}
                            newCall={this.state.newCall}
                            newCallType={this.state.newCallType}
                            handleBackFromNewCall={this.handleBackFromNewCall}
                            handleMakeNewCall={this.handleMakeNewCall}
                        />
                    )}
                </div>
                {open && modelType === 'action' && <ActionPopUp {...this.props.popUpData} />}
                {open && modelType === 'participants' && <ParticipantPopUp />}
                {open && ['callparticipants', 'inviteParticipants', 'calllogparticipants'].indexOf(modelType) > -1 && (
                    <CallParticipantsPopup />
                )}
                {open && ['mediaPermissionDenied', 'mediaAccessError'].indexOf(modelType) > -1 && <MediaErrorPopup />}
                {callConversionData.status && (
                    <CallConversionPopup
                        callConversionData={callConversionData}
                        resetCallConversionRequestData={this.resetCallConversionRequestData}
                        currentUserRequestingCallSwitch={this.currentUserRequestingCallSwitch}
                        remoteUserRequestingCallSwitch={this.remoteUserRequestingCallSwitch}
                    />
                )}
                {open && modelType === 'CallConfirm' && (
                    <Modal containerId="container">
                        <ActionPopup
                            handleActionText={'Ok'}
                            handleCancelText={'Cancel'}
                            handleAction={() => this.handleJoinCallAction()}
                            handleCancel={() => this.handleCancel()}
                            text={'Do you want to leave your call to join this one?'}
                        />
                    </Modal>
                )}
                <InviteDialog open={inviteDialogOpen} onOpenChange={this.handleInviteOpenChange} />
                <CreateChatHost flow={createChatFlow} onClose={() => this.setState({ createChatFlow: null })} />
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        featureStateData: state.featureStateData,
        popUpData: state.popUpData,
        vCardData: state.vCardData,
        callLogData: state.callLogData,
        callConversionData: state.callConversionData,
        browserNotifyData: state.browserNotifyData,
        isEnableArchived: state?.webLocalStorageSetting?.isEnableArchived,
        contactPermission: state?.contactPermission?.data,
        archivedChatsCount: (state?.recentChatData?.data || []).filter(item => item?.archiveStatus === 1).length,
        starredMessagesCount: (state?.starredMessages?.data || []).length,
        unreadChatsCount: countUnreadChats(state),
    };
};

const mapDispatchToProps = {
    resetWallpaperColor,
    wallpaperPreviewSection,
    requestCall,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);

Sidebar.propTypes = {
    resetWallpaperColor: PropTypes.func,
    wallpaperPreviewSection: PropTypes.func,
    requestCall: PropTypes.func,
};
